import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { isEmpty } from 'lodash';

import { ValidationErrorMessages } from '@constants/forms';
import { BooleanSelection } from '@src/types/index';
import { YourAccountFormValues } from '@src/types/yourDetails';
import {
  validateContactNumber,
  validateDob,
  validateEmailAddress,
  validateName,
  validatePassword,
} from '@utils/validators';

import { YourAccountFormErrors } from '../types';

dayjs.extend(customParseFormat);

const validateAdditionalAccount = (values: YourAccountFormValues) => {
  const errors: YourAccountFormErrors = {};

  if (values.yaAdditionalAccount === BooleanSelection.No) {
    return errors;
  }

  if (!values.yaAdditionalAccountNameTitle) {
    errors.yaAdditionalAccountNameTitle =
      ValidationErrorMessages.FIELD_REQUIRED;
  }

  const additionalFirstNameError = validateName(
    values.yaAdditionalAccountNameFirst
  );
  if (additionalFirstNameError) {
    errors.yaAdditionalAccountNameFirst = additionalFirstNameError;
  }

  const additionalLastNameError = validateName(
    values.yaAdditionalAccountNameLast
  );
  if (additionalLastNameError) {
    errors.yaAdditionalAccountNameLast = additionalLastNameError;
  }

  const dobError = validateDob(values.yaAdditionalAccountDoB);
  if (dobError) {
    errors.yaAdditionalAccountDoB = dobError;
  }

  const contactNumberError = validateContactNumber(
    values.yaAdditionalAccountContactNumber
  );
  if (contactNumberError) {
    errors.yaAdditionalAccountContactNumber = contactNumberError;
  }

  const emailError = validateEmailAddress(
    values.yaAdditionalAccountEmail,
    true
  );
  if (emailError) {
    errors.yaAdditionalAccountEmail = emailError;
  }

  return errors;
};

const validateSecondCbcAccount = (values: YourAccountFormValues) => {
  const errors: YourAccountFormErrors = {};

  if (values.yaSecondCbcAccount === BooleanSelection.No) {
    return errors;
  }

  if (!values.yaSecondCbcNameTitle) {
    errors.yaSecondCbcNameTitle = ValidationErrorMessages.FIELD_REQUIRED;
  }

  const cbcFirstNameError = validateName(values.yaSecondCbcNameFirst);
  if (cbcFirstNameError) {
    errors.yaSecondCbcNameFirst = cbcFirstNameError;
  }

  const cbcLastNameError = validateName(values.yaSecondCbcNameLast);
  if (cbcLastNameError) {
    errors.yaSecondCbcNameLast = cbcLastNameError;
  }

  const dobError = validateDob(values.yaSecondCbcDoB);
  if (dobError) {
    errors.yaSecondCbcDoB = dobError;
  }

  const contactNumberError = validateContactNumber(
    values.yaSecondCbcContactNumber
  );

  if (
    contactNumberError &&
    contactNumberError !== ValidationErrorMessages.FIELD_REQUIRED
  ) {
    errors.yaSecondCbcContactNumber = contactNumberError;
  }

  const emailError = validateEmailAddress(values.yaSecondCbcEmail);
  if (emailError) {
    errors.yaSecondCbcEmail = emailError;
  }

  return errors;
};

const validate = (values: YourAccountFormValues) => {
  let errors: YourAccountFormErrors = {};

  const passwordError = validatePassword(values.yaPassword);
  if (passwordError) {
    errors.yaPassword = passwordError;
  }

  const additionalAccountErrors = validateAdditionalAccount(values);
  if (!isEmpty(additionalAccountErrors)) {
    errors = {
      ...errors,
      ...additionalAccountErrors,
    };
  }

  const secondCbcAccountErrors = validateSecondCbcAccount(values);
  if (!isEmpty(secondCbcAccountErrors)) {
    errors = {
      ...errors,
      ...secondCbcAccountErrors,
    };
  }

  return errors;
};

export { validate };
